import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    buyerAPI: 'api.gridmarkets.com:8003/api/render/1.0',
    status: '',
    basic_token: localStorage.getItem('basic_token') || '',
    linkedin_token: localStorage.getItem('linkedin_token') || '',
    user: {
      linkedin_email: localStorage.getItem("linkedin_email") || null,
      name: localStorage.getItem("username") || null,
      email: localStorage.getItem("useremail") || null,
      password: localStorage.getItem("userpwd") || null,
      ispassword: JSON.parse(localStorage.getItem("ispassword")) || false,
      advanced_view: JSON.parse(localStorage.getItem("adv_view")) || false,
      flat_view: JSON.parse(localStorage.getItem("flat_view")) || false
    },
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
    },
    auth_basic_success(state, token){
      state.status = 'success'
      state.basic_token = token
    },
    auth_linkedin_success(state, token){
      state.status = 'success'
      state.linkedin_token = token
    },
    auth_username(state, username){
      state.user.name = username;
    },
    auth_user(state, user){
      state.user = user
    },
    auth_error(state){
      state.status = 'error'
    },
    user_views(state, views){
      state.user.advanced_view = views.advanced_view;
      state.user.flat_view = views.flat_view;
    },
    logout(state){
      state.status = ''
      state.basic_token = null
      state.linkedin_token = null
    },
  },
  actions: {
    basic_login({commit}, user){
      return new Promise((resolve, reject) => {
        let auth_string_buffer = Buffer.from(user.email + ":" + user.password);
        axios.defaults.headers.common['Authorization'] = `Basic ${auth_string_buffer.toString("base64")}`;
        if (user.ispassword){
          axios.defaults.headers.common["GridMarkets-APIKey"] = "6c1523b3-5c5a-433c-96f1-72fe04ec407a";
        }else{
          delete axios.defaults.headers.common["GridMarkets-APIKey"];
        }

        commit('auth_request')
        axios.get(`https://${this.state.buyerAPI}/storagecredentials?v=3.0.1`)
        .then(resp => {
          localStorage.setItem('basic_token', auth_string_buffer.toString("base64"))
          localStorage.setItem('useremail', user.email)
          localStorage.setItem('userpwd', user.password)
          localStorage.setItem('ispassword', `${user.ispassword}`)
          localStorage.removeItem('linkedin_email', user.email)
          user.linkedin_email = null;

          commit('auth_basic_success', `${auth_string_buffer.toString("base64")}`)
          commit('auth_user', user)
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          reject(err)
        })
      })
    },
    linkedin_login({commit}, user){
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`;
        axios.defaults.headers.common["GridMarkets-APIKey"] = "6c1523b3-5c5a-433c-96f1-72fe04ec407a";

        commit('auth_request')
        axios.get(`https://${this.state.buyerAPI}/storagecredentials?v=3.0.1`)
        .then(resp => {
          user.email = resp.data.data.email
          localStorage.setItem('linkedin_email', user.email);
          localStorage.setItem('ispassword', true);
          localStorage.setItem('linkedin_token', user.token)
          user.linkedin_email = user.email;

          commit('auth_linkedin_success', user.token)
          commit('auth_user', user)
          resolve(resp)
        })
        .catch(err => {
          console.log(err);
          commit('auth_error')
          localStorage.removeItem('token')
          reject(err)
        })
      })
    },
    update_user_name({commit}, username){
      return new Promise((resolve) => {
        localStorage.setItem('username', username);
        commit('auth_username', username)
        resolve()
      })
    },
    logout({commit}){
      return new Promise((resolve) => {
        commit('logout')
        localStorage.removeItem('basic_token')
        localStorage.removeItem('linkedin_token')
        localStorage.removeItem("username")
        localStorage.removeItem("useremail")
        localStorage.removeItem("userpwd")
        localStorage.removeItem("ispassword")
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
    update_user_views({commit}, user_views){
      return new Promise((resolve) => {
        if (user_views.advanced_view){
          localStorage.setItem('adv_view', user_views.advanced_view);
        }else{
          localStorage.removeItem('adv_view');
        }
        if (user_views.flat_view){
          localStorage.setItem('flat_view', user_views.flat_view);
        }else{
          localStorage.removeItem('flat_view');
        }
        commit('user_views', user_views)
        resolve()
      })
    }
  },
  getters : {
    isLoggedIn: state => state.basic_token || state.linkedin_token || false,
    authStatus: state => state.status,
    userLoggedIn: state => state.user,
    advancedView: state => state.user.advanced_view || false,
    flatView: state => state.user.flat_view || false
  }
})